import { Box } from "@mui/material";
import BeeIcon from "./BeeIcon";

/**
 * Dizzy Bee - Used for rate limit states
 * Shows the standard bee with animated spinning stars around its head
 */
export default function DizzyBeeIcon({ sx = {} }) {
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...sx,
      }}
    >
      {/* The Bee */}
      <Box
        sx={{
          animation: "wobble 2s ease-in-out infinite",
          "@keyframes wobble": {
            "0%, 100%": { transform: "rotate(-3deg)" },
            "50%": { transform: "rotate(3deg)" },
          },
        }}
      >
        <BeeIcon sx={{ fontSize: "inherit" }} />
      </Box>

      {/* Spinning Stars Container */}
      <Box
        sx={{
          position: "absolute",
          top: "-15%",
          left: "50%",
          transform: "translateX(-50%)",
          width: "100%",
          height: "40%",
          animation: "spinStars 3s linear infinite",
          "@keyframes spinStars": {
            "0%": { transform: "translateX(-50%) rotate(0deg)" },
            "100%": { transform: "translateX(-50%) rotate(360deg)" },
          },
        }}
      >
        {/* Star 1 - Top */}
        <Box
          component="span"
          sx={{
            position: "absolute",
            top: "0%",
            left: "50%",
            transform: "translateX(-50%)",
            fontSize: { xs: "1.5rem", md: "2rem" },
            animation: "twinkle 0.5s ease-in-out infinite alternate",
            "@keyframes twinkle": {
              "0%": { opacity: 0.5, transform: "translateX(-50%) scale(0.8)" },
              "100%": { opacity: 1, transform: "translateX(-50%) scale(1.1)" },
            },
          }}
        >
          ⭐
        </Box>

        {/* Star 2 - Left */}
        <Box
          component="span"
          sx={{
            position: "absolute",
            top: "50%",
            left: "15%",
            fontSize: { xs: "1.2rem", md: "1.5rem" },
            animation: "twinkle 0.6s ease-in-out infinite alternate",
            animationDelay: "0.2s",
          }}
        >
          ✨
        </Box>

        {/* Star 3 - Right */}
        <Box
          component="span"
          sx={{
            position: "absolute",
            top: "50%",
            right: "15%",
            fontSize: { xs: "1.2rem", md: "1.5rem" },
            animation: "twinkle 0.6s ease-in-out infinite alternate",
            animationDelay: "0.4s",
          }}
        >
          ✨
        </Box>
      </Box>
    </Box>
  );
}
